/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Snigdha Dhanireddy <snigdha.dhanireddy@mroads.com>, June 2023
 * @flow
 */

import React, { useState, useEffect } from 'react';
import classes from './ElapsedTimer.module.css';
import TimeConstants from '../../../../constants/time-constants';
import TMSUtils from '../../../../util/tms-util';

const ElapsedTime = ({ bookingDate, elapsedTime }) => {
    const [time, setTime] = useState(elapsedTime);

    useEffect(() => {
        const interval = setInterval(() => {
            const calculatedElapsedTime = TMSUtils.getElapsedTime(bookingDate);
            setTime(calculatedElapsedTime);
        }, TimeConstants.SECOND);
        return () => {
            clearInterval(interval);
        };
    }, [bookingDate]);

    return (
        <div className={classes.smallerFont}>{TMSUtils.showTimeInMinsSecs(time)}</div>
    );
};

export default ElapsedTime;
